import Vue from "vue";
import Vuex from "vuex";
import clubStore from "./clubs";
import userStore from "./users";
import playerStore from "./players";
import UserInfo from "./module/userInfo.js";
import playerDetail from "./module/playerdetail.js";
// import playerDetail from "./players";
import collegeStore from "./colleges";
import searchStore from "./search";
import favouriteStore from "./favourites";
import athleteStore from "./athletes";
import athleteEventStore from "./athlete-events";
import clubEventStore from "./club-events";
import collegeEventStore from "./college-events";
import coachStore from "./coaches";
import newsStore from "./news";
import rosterStore from "./roster";
import collegeTeamHighlightStore from "./college-team-highlight";
import clubTeamHighlightStore from "./club-team-highlight";
import chatStore from "./chat";
import miscStore from "./misc";
import complainStore from "./complain";
import paymentStore from "./payments";
import homeStore from "./home";
import notificationStore from "./notification"
// Load Vuex
Vue.use(Vuex);

// Create Store
export default new Vuex.Store({
  modules: {
    clubStore,
    userStore,
    playerStore,
    UserInfo,
    playerDetail,
    collegeStore,
    searchStore,
    favouriteStore,
    athleteStore,
    athleteEventStore,
    clubEventStore,
    collegeEventStore,
    coachStore,
    newsStore,
    rosterStore,
    collegeTeamHighlightStore,
    clubTeamHighlightStore,
    chatStore,
    miscStore,
    complainStore,
    paymentStore,
    homeStore,
    notificationStore,
  }
});
